import { Button } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";
import I18n from "app/pages/sales-intelligence/common-components/i18n/I18n";
import { AssetsService } from "app/services/AssetsService";
import { ProModal } from "pro-features/components/Modals/src/ProModal";
import { FlexColumn } from "pro-features/styled components/StyledFlex/src/StyledFlex";

import {
    CUSTOM_MODAL_STYLES,
    StyledButtonsContainer,
    StyledImg,
    StyledMainContainer,
    StyledSubtitle,
    StyledTitle,
} from "./styles";

export type SaveSearchTriggerModalProps = {
    isOpen: boolean;
    onConfirm(): void;
    onCancel(): void;
};

const SaveSearchTriggerModal = (props: SaveSearchTriggerModalProps) => {
    const { isOpen, onConfirm, onCancel } = props;

    return (
        <ProModal
            isOpen={isOpen}
            showCloseIcon={false}
            shouldCloseOnOverlayClick={false}
            customStyles={CUSTOM_MODAL_STYLES}
        >
            <FlexColumn data-automation="save-search-trigger-modal">
                <StyledImg
                    src={AssetsService.assetUrl("images/sales-intelligence/paper-list-with-magnet.svg")}
                    alt="paper with magnet"
                />

                <StyledMainContainer>
                    <I18n
                        element={StyledTitle}
                        data-automation="modal-title"
                        translatable={{ key: "si.components.save_search_trigger_modal.title" }}
                    />
                    <I18n
                        element={StyledSubtitle}
                        data-automation="modal-subtitle"
                        translatable={{
                            key: "si.components.save_search_trigger_modal.subtitle",
                        }}
                    />
                </StyledMainContainer>

                <StyledButtonsContainer>
                    <Button
                        dataAutomation="save-search-confirm-button"
                        onClick={onConfirm}
                    >
                        {translate("si.components.save_search_trigger_modal.button.confirm")}
                    </Button>

                    <Button
                        type="flat"
                        dataAutomation="save-search-cancel-button"
                        onClick={onCancel}
                    >
                        {translate("si.components.save_search_trigger_modal.button.cancel")}
                    </Button>
                </StyledButtonsContainer>
            </FlexColumn>
        </ProModal>
    );
};

export default SaveSearchTriggerModal;
